/**
 * Utility functions for fetching cryptocurrency prices
 */

/**
 * Fetches the current SOL price from CoinGecko API
 * @returns {Promise<number>} The current SOL price in USD
 */
export const fetchSolPrice = async () => {
  try {
    const response = await fetch(
      'https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd'
    );
    
    if (!response.ok) {
      throw new Error(`CoinGecko API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.solana.usd;
  } catch (error) {
    console.error('Error fetching SOL price:', error);
    return null;
  }
};

/**
 * Calculates the time until the next Friday at 8 PM UTC
 * @returns {Object} Object containing days, hours, minutes until next Friday 8 PM UTC
 */
export const getTimeUntilFridayLottery = () => {
  const now = new Date();
  
  // Create a date for the next Friday at 8 PM UTC
  const fridayLottery = new Date();
  
  // Set to 8 PM UTC (20:00)
  fridayLottery.setUTCHours(20, 0, 0, 0);
  
  // Get current day of week (0 = Sunday, 1 = Monday, ..., 5 = Friday, ...)
  const currentDay = now.getUTCDay();
  
  // Calculate days until next Friday
  // If today is Friday and it's before 8 PM UTC, next lottery is today
  // If today is Friday and it's after 8 PM UTC, next lottery is next Friday
  // Otherwise, calculate days until next Friday
  let daysUntilFriday;
  
  if (currentDay === 5) { // Friday
    if (now.getUTCHours() < 20 || (now.getUTCHours() === 20 && now.getUTCMinutes() === 0)) {
      daysUntilFriday = 0;
    } else {
      daysUntilFriday = 7;
    }
  } else {
    daysUntilFriday = currentDay < 5 ? 5 - currentDay : 7 - (currentDay - 5);
  }
  
  // Add days to the lottery date
  fridayLottery.setUTCDate(fridayLottery.getUTCDate() + daysUntilFriday);
  
  // Calculate time difference in milliseconds
  const timeDifference = fridayLottery - now;
  
  // Convert to days, hours, minutes
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  
  return {
    days,
    hours,
    minutes,
    totalMilliseconds: timeDifference
  };
};
